import { store as data_store } from '../../store.ts'
import { clear_login_credentials, get_site_auth_header } from '../auth/module.ts'
import { BACKEND_SERVER } from '../common/env.ts'
import { to_title_case } from '../common/module.ts'
import PdfLineItem from '../pdf/types/PdfLineItem.ts'

export interface ProjectOrPurchaseOrder {
    response_status: number,
    description: string,
	customer: string,
	projectManager: string,
    lineItems: PdfLineItem[]
}

//Not found
//Rate Limit
//Site Auth Failed
//Accumatica Auth Failed
//Other Server Error

export async function get_project_or_purchase_order(arg_NaN: string): Promise<ProjectOrPurchaseOrder> {
    const loc_NaN = encodeURIComponent(arg_NaN)

    if (loc_NaN.startsWith('1')) {
        let loc_purchase_order = await get_purchase_order(loc_NaN)
        loc_purchase_order.projectManager = to_title_case(loc_purchase_order.projectManager)
        return loc_purchase_order
    } else {
        let loc_project = await get_project(loc_NaN)
        loc_project.projectManager = to_title_case(loc_project.projectManager)
        loc_project.lineItems = []
        return loc_project
    }
}

export async function get_project(arg_project_NaN: string): Promise<ProjectOrPurchaseOrder> {
    try {
        const project_repsonse = await fetch(BACKEND_SERVER + '/accumatica/project/' + arg_project_NaN, 
            {
                headers: get_site_auth_header(),
            }
        )

        if (project_repsonse.status == 401) {
            const response_text = await project_repsonse.text()
            if (response_text.includes("accumatica auth failed")) {
                const store = data_store()
                store.set_accumatica_authed(false)
                return {
                    response_status: 401,
                    description: "", 
                    customer: "",
                    projectManager: "",
                    lineItems: []
                }
            } else if (response_text.includes("site auth failed")) {
                clear_login_credentials()
                return {
                    response_status: 401,
                    description: "", 
                    customer: "",
                    projectManager: "",
                    lineItems: []
                }
            } else {

            }
        } else if (project_repsonse.status == 404) {
            return {
                response_status: 404,
                description: "", 
                customer: "",
                projectManager: "",
                    lineItems: []
            }
            // Not Found
        } else if (project_repsonse.status == 429) {
            return {
                response_status: 429,
                description: "", 
                customer: "",
                projectManager: "",
                    lineItems: []
            }
            // Rate limit
        } else if (project_repsonse.status != 200) {
            return {
                response_status: 500,
                description: "", 
                customer: "",
                projectManager: "",
                lineItems: []
            }
            // Other Server error
        }

        let project = await project_repsonse.json() as ProjectOrPurchaseOrder
	    project.response_status = 200

        return project
    } catch (e) {
        //TODO add proper tracing
        // Other Server error
        console.log(e)
        throw e
    }

    return {} as ProjectOrPurchaseOrder
}

export async function get_purchase_order(arg_purchase_order_NaN: string): Promise<ProjectOrPurchaseOrder> {
    try {
        const purchase_order_repsonse = await fetch(BACKEND_SERVER + '/accumatica/purchase_order/' + arg_purchase_order_NaN, 
            {
                headers: get_site_auth_header(),
            }
        )

        if (purchase_order_repsonse.status == 401) {
            const response_text = await purchase_order_repsonse.text()
            if (response_text.includes("accumatica auth failed")) {
                const store = data_store()
                store.set_accumatica_authed(false)
                return {
                    response_status: 401,
                    description: "", 
                    customer: "",
                    projectManager: ""
                }
            } else if (response_text.includes("site auth failed")) {
                clear_login_credentials()
                return {
                    response_status: 401,
                    description: "", 
                    customer: "",
                    projectManager: ""
                }
            } else {

            }
        } else if (purchase_order_repsonse.status == 404) {
            return {
                response_status: 404,
                description: "", 
                customer: "",
                projectManager: ""
            }
            // Not Found
        } else if (purchase_order_repsonse.status == 429) {
            return {
                response_status: 429,
                description: "", 
                customer: "",
                projectManager: ""
            }
            // Rate limit
        } else if (purchase_order_repsonse.status != 200) {
            return {
                response_status: 500,
                description: "", 
                customer: "",
                projectManager: ""
            }
            // Other Server error
        }
	
        let purchase_order = await purchase_order_repsonse.json() as ProjectOrPurchaseOrder
	    purchase_order.response_status = 200
        return purchase_order
    } catch (e) {
        //TODO add proper tracing
        console.log(e)
        throw e
    }

    return {} as ProjectOrPurchaseOrder
}
